import script from "./NoteCustomTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteCustomTextarea.vue?vue&type=script&setup=true&lang=js"

import "./NoteCustomTextarea.vue?vue&type=style&index=0&id=2dae41c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dae41c6"]])

export default __exports__